import { B } from "../data/pillars";

export default function SectionHeader({ num, title, sub }) {
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 14, marginBottom: 20 }}>
      <div style={{ width: 36, height: 36, borderRadius: 8, background: B.blue, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 800, color: B.white, flexShrink: 0 }}>
        {String(num).padStart(2, "0")}
      </div>
      <div>
        <div style={{ fontSize: 18, fontWeight: 800, color: B.white, letterSpacing: 0.5 }}>{title}</div>
        <div style={{ fontSize: 11, color: B.subText, letterSpacing: 2, textTransform: "uppercase", marginTop: 2 }}>{sub}</div>
      </div>
    </div>
  );
}